import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../../mutation-types';
import productAPI from '../../../../api/product';
import alertHelper from '../../../../helpers/alert';

const defaultState = () => ({
    allProduct: {},
    productOne: {},
    alert: [],
    recomendedProduct: []
});

const state = defaultState();

const mutations = {
    defineAllProduct(state, data) {
        state.allProduct = Object.assign({}, state.allProduct, data);
    },
    defineRecomendedProduct(state, data) {
        state.recomendedProduct = data
    },
    defineProductOne(state, data) {
        state.productOne = Object.assign({}, state.productOne, data);
    },
    failed(state, { code, type, message }) {
        state.alerts = alertHelper.make(state.alerts, code, type, message);
    },
    reset(state) {
        Object.assign(state, defaultState());
    },
};

const actions = {
    getRecomendedProduct({ commit, dispatch }) {

        commit(PROGRESS_START, null, { root: true });

        productAPI.recomendedProduct().then(({ data: { data } }) => {
            commit('defineRecomendedProduct', data.results);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getAllProduct({ commit, dispatch }) {

        commit(PROGRESS_START, null, { root: true });

        productAPI.allProduct().then(({ data: { data } }) => {
            commit('defineAllProduct', data.results);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getProductDetail({ state, commit, dispatch }, code) {
        if (code === state.productOne.product_code) {
            return;
        } else {
            commit(PROGRESS_START, null, { root: true });

            productAPI.detailProduct(code).then(({ data: { data } }) => {
                commit('defineProductOne', data);
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                const { data } = err.response;
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
        }
    },
    errorHandler({ commit }, response) {
        commit('failed', { code: 'error_response', type: 'error', message: response.message });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};